export var ConnectCaseMappingStatus;
(function (ConnectCaseMappingStatus) {
    ConnectCaseMappingStatus["Exported"] = "EXPORTED";
    ConnectCaseMappingStatus["Retracted"] = "RETRACTED";
    ConnectCaseMappingStatus["Completed"] = "COMPLETED";
    ConnectCaseMappingStatus["DataUpdated"] = "DATA_UPDATED";
})(ConnectCaseMappingStatus || (ConnectCaseMappingStatus = {}));
export var RetractionReason;
(function (RetractionReason) {
    RetractionReason["Collected"] = "COLLECTED";
    RetractionReason["ConnectionDisabled"] = "CONNECTION_DISABLED";
    RetractionReason["Rollback"] = "ROLLBACK";
    RetractionReason["Other"] = "OTHER";
})(RetractionReason || (RetractionReason = {}));
export var CompletionReason;
(function (CompletionReason) {
    CompletionReason["Collected"] = "COLLECTED";
    CompletionReason["TaskCompleted"] = "TASK_COMPLETED";
})(CompletionReason || (CompletionReason = {}));
export var EntityType;
(function (EntityType) {
    EntityType["Customer"] = "CUSTOMER";
    EntityType["Document"] = "DOCUMENT";
    EntityType["VoucherType"] = "VOUCHER_TYPE";
    EntityType["Interaction"] = "INTERACTION";
})(EntityType || (EntityType = {}));
//# sourceMappingURL=index.js.map